import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"
import Img from "gatsby-image"
import { SRLWrapper } from "simple-react-lightbox"
import PageTransition from "gatsby-v2-plugin-page-transitions"
import galleryLargeStyles from "./gallerylarge.module.scss"

import { Link, graphql, useStaticQuery } from "gatsby"

export const query = graphql`
  query($slug: String!) {
    contentfulAlbum(nazwa: { eq: $slug }) {
      nazwa
      typ
      zdjecia {
        fluid(maxHeight: 2000) {
          ...GatsbyContentfulFluid
        }
        file {
          url
        }
      }
    }
  }
`

const gallerylarge = props => {
  return (
    <Layout>
      <Head title={props.data.contentfulAlbum.nazwa} />

      <h1 className="page_heading">{props.data.contentfulAlbum.nazwa}</h1>

      <ul className="breadcrumbs">
        <li className="breadcrumbs__item">
          <Link to="/#portfolio">Portfolio</Link>
        </li>
        <li className="breadcrumbs__item">
          <Link to={`/${props.data.contentfulAlbum.typ}`}>
            {props.data.contentfulAlbum.typ}
          </Link>
        </li>
        <li className="breadcrumbs__item current">
          {props.data.contentfulAlbum.nazwa}
        </li>
      </ul>
      
        <section className={galleryLargeStyles.gallery}>
        <PageTransition>
          <SRLWrapper>
            <div className={galleryLargeStyles.gallery_container}>
              {props.data.contentfulAlbum.zdjecia.map(zdjecie => {
                return (
                  <div className={galleryLargeStyles.gallery__item}>
                    <Link to={zdjecie.file.url}>
                      <Img
                        fluid={zdjecie.fluid}
                        className={galleryLargeStyles.gallery__item_img}
                      ></Img>
                    </Link>
                  </div>
                )
              })}
            </div>
          </SRLWrapper>
          </PageTransition>
        </section>
      
    </Layout>
  )
}

export default gallerylarge
